"use strict";

angular.module("internal.exams").directive("internalExamAdminNavigation", [
    function() {
        return {
            restrict: "E",
            templateUrl:
                paths.app +
                "exams/components/exam-admin-navigation/exam-admin-navigation.html",
            replace: true,
            controller: "InternalNavigation"
        };
    }
]);
